export default {
  init() {
    // JavaScript to be fired on all pages
    $('.main').on('click', '.calevir_loadmore', function (e) {
      e.preventDefault();
      var calevir_loadmore_params = { 'ajaxurl': '/wp-admin/admin-ajax.php', 'posts': '', 'current_page': '1', 'max_page': null };
      var button = $(this),
        data = {
          'action': 'loadmore',
          'page': $(this).data('num'),
        };
      $.ajax({
        url: calevir_loadmore_params.ajaxurl,
        data: data,
        type: 'POST',
        cache: false,
        dataType: 'JSON',
        beforeSend: function () {
          button.text('Loading...');
        },
        success: function (data) {
          if (data) {
            if (data.actiondata) {
              $('#blog-result').append(data.actiondata);
            }
            button.text('View More');
            calevir_loadmore_params.current_page++;
            if (calevir_loadmore_params.current_page == button.data('num')) {
              button.remove();
            }
          } else {
            button.remove();
          }
        },
      });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('#navbar-primary .navbar-nav li.dropdown .nav-link').click(function (e) {
      if ($(window).width() < 1200) {
        var grandparent = $(this).next();
        if ($(this).hasClass('open1') && grandparent.hasClass('opened')) {
          document.location.href = this.href;
        } else {
          $(this).addClass('open1');
          $('#navbar-primary .navbar-nav').find('i').removeClass('opened');
          $(this).next('.dropdown-toggle1').click();
        }
      } else {
        location.href = this.href;
      }
      e.preventDefault();
    });

    $('li.dropdown > .dropdown-toggle1').on('click', function (e) {
      var current = $(this).next();
      var current1 = $(this);
      var grandparent = $(this).parent().parent();
      grandparent.find('.dropdown-menu:visible').not(current).removeClass('show1');
      grandparent.find('.dropdown-toggle1').not(current1).removeClass('opened');
      $(this).toggleClass('opened');
      current.toggleClass('show1');
      e.stopPropagation();
    });

    $('.banner_slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: true,
      adaptiveHeight: false,
      autoplaySpeed: 100000,
    });

    $('.reviews_slider').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000,
      accessibility: false,

      responsive: [{
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      ],
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js